import autocolors from "chartjs-plugin-autocolors";
import {IChartConfig, TypeChart} from "../interfaces/chat";
import {cssClass} from "lib-base";

export class GraphicsAssistant {
  title?: string;
  data: any[] | undefined;
  options: any;
  styles?: { [key: string]: string } | null;
  _datasets: any;
  height?: string;
  width?: string;
  class?: cssClass;
  time?: 'day' | 'week' | 'month' | 'year';


  public configOptions(config: IChartConfig) {
    const xAxis:Scale = {};
    if (this.time && config.minLine && config.maxLine) {
      xAxis.type = 'time';
      xAxis.time = {
        unit: this.time,
        min: config.minLine,
        max: config.maxLine
      }
    }

    this.options = {
      indexAxis: config.orientation,
      responsive: true,
      scales: {
        x: xAxis,
        y: {beginAtZero: true} as Scale,
      },
      plugins: {
        colors: autocolors,
        legend: {
          labels: {
            color: '#fff'
          }
        },
        title: {
          display: true,
          text: this.title,
          color: '#fff'
        }
      },
    }

  }

  set datasets(datasets: any) {
    this._datasets = datasets;
  }

  generateChart(config: IChartConfig, data: any[]) {
    if (!config) return;
    this.data = data;
    const categories: string[] = [...new Set(this.data?.map(item => item[config.xAxis]) as string[])];
    this.datasets = {
      labels: categories,
      datasets: config.yAxis.map((label: string, index: number) => {
        return {
          label: label,
          type: config?.typeChart.toLowerCase(),
          backgroundColor: GraphicsAssistant.getColors(index, config?.typeChart),
          data: this.data?.map(item => item[label])
        }
      })
    }
    this.configOptions(config);
  }

  public static groupArray<T extends Record<string, any>>(array: T[], field: keyof T): any {
    if (!array || !field) return [];
    return array?.reduce((acc: Record<string, any[]>, current) => {
      const item = current[field];
      if (!acc[item])
        acc[item] = [];
      acc[item].push(current);
      return acc;
    }, {});
  }

  public static limpiarYFormatearCampo(input: any) {
    if (typeof input !== 'string') return input;
    return input.trim().replace(/\s+/g, '_');
  }

  public static getColors(index: number, typeChart?: TypeChart): string | string[] {
    const colors = [
      '#00CFFF',
      '#0044A0',
      '#008CDB',
      '#002F8C',
      '#00A2E8',
      '#0075C9',
      '#00B7F2',
      '#005BB5',
      '#05466f',
    ];
    if (typeChart != null && typeChart == 'doughnut' || typeChart != null && typeChart == 'pie') {
      return colors;
    }
    return colors[index % colors.length];
  }
}

export interface ChartContainer {
  title?:string;
  options:ChartOptions;
  data: Data;
  class?: cssClass;
  classContainer?: cssClass;

}

export interface Data {
  labels?: string[];
  datasets: Dataset[];
}

export interface Dataset {
  label?: string;
  type: string;
  backgroundColor?: string | string[];
  borderColor?: string | string[];
  data: any[] | undefined;
}

export interface ChartOptions {
  responsive: boolean;
  type: Exclude<TypeChart, 'polarArea' | 'stacked'>;
  indexAxis: 'x' | 'y';
  scales?: {
    x?: Scale;
    y?: Scale;
  },
  parsing?: ParsingXY | ParsingRound;
  plugins?: {
    colors?: autocolors,
    legend?: {
      labels: {
        color: string
      }
    },
    annotation?:any;
    title?: {
      display?: boolean,
      text: string
      color: string
    }
  },
  datasetConfig?: DatasetConf[];
  groups?:Group[];
  title?:string;
  customType?: 'gauge';
}

export interface DatasetConf {
  key: string;
  title: string;
  type: Exclude<TypeChart, 'polarArea' | 'stacked'>;
  data?:any[];
}

export interface Group {
  key: string;
  type: string;
}

export interface Scale {
  stacked?: boolean;
  beginAtZero?: boolean;
  type?: string;
  time?: {
    unit: string;
    min: string;
    max: string;
  };
  title?: {
    display: boolean;
    text: string;
  };
  grid?: {
    color: string;
  };
  ticks?: {
    color: string;
  }
}

export interface ParsingXY  {
  xAxisKey?: string;
  yAxisKey?: string;
}

export interface ParsingRound  {
  key?: string;
}
